import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';
/**
 * 打开发短信应用, 并初始化接受者电话, 短信内容
 */
export type FabricUtilsSendTextMsgOptions = {
  /**
   * 接受者电话
   */
  receiver?: string;
  /**
   * 短信内容
   */
  body?: string;
};

export type FabricUtilsSendTextMsgApi = (
  options: FabricUtilsSendTextMsgOptions
) => Promise<boolean>;

/**
 * 打开发短信应用, 并初始化接受者电话, 短信内容
 */
export const sendTextMsg: FabricUtilsSendTextMsgApi = (options) => {
  return new Promise<boolean>((resolve, reject) => {
    core.call<'fabric_utils.sendMsg', FabricUtilsSendTextMsgOptions, boolean>(
      'fabric_utils.sendMsg',
      options,
      (result) => {
        const fabricErrors = filterFabricErrors(
          result.code,
          result.message,
          result.data
        );
        if (fabricErrors) {
          reject(fabricErrors);
        } else {
          resolve(result.data);
        }
      }
    );
  });
};
